/**
 * @file all-products.tsx
 * @module app/modules/all-products/all-products
 * @description All products listing module page.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from "react";
import { Button, Card, Col, Image, Nav, Row, Tab } from "react-bootstrap";
import { KTSVG } from "../../../_admin/helpers";
import gray from "../../../_admin/assets/media/svg_uTrade/gray_dot.svg";
import green from "../../../_admin/assets/media/svg_uTrade/green_dot.svg";
import ProductRejected from "../../modals/product-rejected";
import {
  Actived,
  AllProduct,
  ApprovedProduct,
  All_Products,
  Deactivated,
  FinanceManager,
  LoadingBayManager,
  PAGE_LIMIT,
  PendingProduct,
  RejectedProduct,
  View,
  PermissionModule,
  Permissions,
} from "../../../utils/constants";
import APICallService from "../../../api/apiCallService";
import { manageProduct, master, product } from "../../../api/apiEndPoints";
import Loader from "../../../Global/loader";
import { useNavigate } from "react-router-dom";
import Method from "../../../utils/methods";
import { productJSON } from "../../../api/apiJSON/product";
import { CustomComponentSelect } from "../../custom/Select/CustomComponentSelect";
import Pagination from "../../../Global/pagination";
import { useAuth } from "../auth";
import { CustomSelect } from "../../custom/Select/CustomSelect";
import {
  listAllProducts,
  listProductDetails,
} from "../../../utils/storeString";
import { getKey, removeAllKeys, setKey } from "../../../Global/history";
import AllProductsReport from "../../modals/report/all-products-report";
import ThreeDotMenu from "../../../_admin/assets/media/svg_uTrade/three-dot.svg";
import { success } from "../../../Global/toast";
import { catalogue, masterToast } from "../../../utils/toast";
import DeleteModal from "../../modals/delete";

import { ElementAnimateUtil } from "../../../_admin/assets/ts/_utils";
import ProductPriceListReport from "../../modals/report/all-products-price-list-report";
import EditSearchTags from "../../modals/searchTagModal";
import { useWarehouse } from "../../context/WarehouseContext";
import { useDebounce } from "../../../utils/useDebounce";
import { useNavigationHistory } from "../../../utils/useNavigationHistory";
import ImageWithFallback from "../_common/components/image-with-fallback";

const AllProducts = () => {
  const { currentUser } = useAuth();
  const { selectedWarehouse } = useWarehouse();
  const navigate = useNavigate();
  const { navigateTo } = useNavigationHistory();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [fetchCategoryLoader, setFetchCategoryLoader] = useState(false);
  const [id, setId] = useState("");
  const [show, setShow] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>();

  const [dataFetched, setDataFetched] = useState(false);

  const [active, setActive] = useState<any>(
    getKey(listAllProducts.currentTab)
      ? () => {
        let temp: any = getKey(listAllProducts.currentTab);
        return parseInt(temp);
      }
      : currentUser?.role.some(
        (obj: any) =>
          obj.type === FinanceManager || obj.type === LoadingBayManager,
      )
        ? ApprovedProduct
        : PendingProduct,
  );
  const [filterProducts, setFilterProducts] = useState([]);
  const [products, setProducts] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState<any>(getKey(listAllProducts.page) || 1);
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listAllProducts.limit) || PAGE_LIMIT,
  );
  const [categories, setCategories] = useState<any>(
    getKey(listAllProducts.filterCategories) || [],
  );
  const [totalCategory, setTotalCategory] = useState<number>(0);
  const [categoryPage, setCategoryPage] = useState(1);
  const [categorySearch, setCategorySearch] = useState("");
  const [rejectedProduct, setRejectedProduct] = useState<any>({});
  const [productState, setProductState] = useState<any>(
    getKey(listAllProducts.filterState) || AllProduct,
  );
  const [productType, setProductType] = useState<string>("all");
  const [search, setSearch] = useState<string>(
    getKey(listAllProducts.search)?.toString() || "",
  );
  const [showSearchTag, setSearchTag] = useState(false);
  const productOptions = [
    {
      value: AllProduct,
      name: "All products",
      label: (
        <>
          <span className="fs-16 fw-600 text-black mb-0">All products</span>
        </>
      ),
      title: "All products",
    },
    {
      value: Actived,
      name: "Active",
      label: (
        <>
          <img src={green} width={12} height={12} className="me-3" alt="" />
          <span className="fs-16 fw-600 text-black ">Active</span>
        </>
      ),
      title: "Active",
    },
    {
      value: Deactivated,
      name: "Deactivated",
      label: (
        <>
          <img src={gray} width={12} height={12} className="me-3" alt="" />
          <span className="fs-16 fw-600 text-black">Deactivated</span>
        </>
      ),
      title: "Deactivated",
    },
  ];
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showDownloadPriceListModal, setShowDownloadPriceListModal] =
    useState(false);
  const [deleteProductModalOpen, setDeleteProductModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [selectedProduct, setSelectedProduct] = useState<any>();

  const [deleteVariantModalOpen, setDeleteVariantModalOpen] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState<any>();
  const [productId, setProductId] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const productTypeOptions = [
    {
      value: "pharmacy",
      name: "Pharmacy",
      label: (
        <>
          <span className="fs-16 fw-600 text-black mb-0">Pharmacy</span>
        </>
      ),
      title: "Pharmacy",
    },
    {
      value: "utrade",
      name: "Utrade",
      label: (
        <>
          <span className="fs-16 fw-600 text-black mb-0">Utrade</span>
        </>
      ),
      title: "Utrade",
    },
  ];

  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      if (!Method.hasModulePermission(All_Products, currentUser)) {
        return window.history.back();
      }
      if (getKey(listAllProducts.currentTab)) {
        let activeTemp: any = getKey(listAllProducts.currentTab);
        await fetchProducts(
          page,
          pageLimit,
          productState,
          categories,
          search,
          parseInt(activeTemp),
        );
      } else {
        setActive(
          currentUser?.role.some(
            (obj: any) =>
              obj.type === FinanceManager || obj.type === LoadingBayManager,
          )
            ? ApprovedProduct
            : PendingProduct,
        );
        await fetchProducts(
          page,
          pageLimit,
          productState,
          categories,
          search,
          active,
        );
      }
      setDataFetched(true);
      setFetchLoader(false);
      await fetchCategory(page, PAGE_LIMIT);
      setDefaultValue({
        label: (
          <img
            className="img-fluid"
            width={24}
            height={5}
            src={ThreeDotMenu}
            alt=""
          />
        ),
        value: (
          <img
            className="img-fluid"
            width={24}
            height={5}
            src={ThreeDotMenu}
            alt=""
          />
        ),
      });
    })();
  }, [selectedWarehouse?.value]);

  useEffect(() => {
    if (dataFetched) {
      let initialScrollPosition: any = getKey(listAllProducts.scrollPosition);
      if (initialScrollPosition) {
        ElementAnimateUtil.scrollTo(parseInt(initialScrollPosition));
        setDataFetched(false);
        setKey(listAllProducts.search, "", false);
        setKey(listAllProducts.filterState, AllProduct, false);
        setKey(listAllProducts.filterCategories, [], false);
      }
      removeAllKeys(listProductDetails);
    }
  }, [dataFetched]);

  const fetchCategory = async (
    page: number,
    limit: number,
    search: string = "",
  ) => {
    setFetchCategoryLoader(true);
    let params: any = {
      pageNo: page,
      limit: limit,
      searchTerm: search,
      sortKey: "title",
      sortOrder: 1,
      needCount: true,
      state: 1,
      categoriesDepth: 1,
    };
    if (selectedWarehouse?.value) {
      params.warehouse = selectedWarehouse?.value;
    }
    let apiService = new APICallService(
      master.categoryList,
      params,
      "",
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.records) {
      response.records = await response.records.map((val: any) => {
        return {
          value: val.title,
          name: val.title,
          id: val._id,
          label: (
            <>
              <div className="symbol symbol-40px symbol-circle border me-2">
                <img src={val.image} className="object-fit-contain" alt="" />
              </div>
              <label
                className="form-check-label fs-16 fw-600 text-dark"
                htmlFor="Ex2"
              >
                {val.title}
              </label>
            </>
          ),
          title: val.title,
        };
      });
      setTotalCategory(response.total);
      let data: any = (prevResults: any) =>
        page === 1 ? response.records : [...prevResults, ...response.records];
      setFilterProducts(data);
    }
    setFetchCategoryLoader(false);
  };
  const onMenuCategoryScrollToBottom = async () => {
    if (!(filterProducts.length === totalCategory)) {
      let tempPage = categoryPage;
      tempPage = tempPage + 1;
      setCategoryPage(tempPage);
      await fetchCategory(tempPage, PAGE_LIMIT, categorySearch);
    }
  };
  const onMenuCategoryClose = async () => {
    setCategorySearch("");
  };
  const onMenuCategoryOpen = async () => {
    setCategoryPage(1);
    await fetchCategory(1, PAGE_LIMIT, categorySearch);
  };
  const handleInputCategoryChange = async (newValue: string) => {
    setCategoryPage(1);
    setCategorySearch(newValue);
    await fetchCategory(1, 0, newValue);
  };
  const fetchProducts = async (
    pageNo: number,
    limit: number,
    state: number,
    categories: any,
    search: string,
    status?: number,
    productTypeValue?: string,
  ) => {
    setLoading(true);
    const selectedProductType = productTypeValue || productType;
    let data: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "_createdAt",
      sortOrder: -1,
      searchTerm: search,
      state: state,
      needCount: true,
      status: status,
    };
    if (selectedProductType === "pharmacy") {
      data.isPharmacyProduct = true;
    } else if (selectedProductType === "utrade") {
      data.excludePharmacyProduct = true;
    }
    if (selectedWarehouse?.value) {
      data = {
        ...data,
        warehouse: selectedWarehouse?.value || null,
      };
    }
    if (categories?.length > 0) {
      categories.map((val: any, index: number) => {
        data = { ...data, ["categories[" + index + "]"]: val.id };
      });
    }
    let apiService = new APICallService(
      manageProduct.listProduct,
      data,
      "",
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response?.records) {
      setTotalRecords(response?.total);

      response.records = response?.records?.map((p: any) => ({
        ...p,
        variants: p.variants.map((v: any) => ({
          ...v,
          variant: {
            ...v.variant,
            active: v.variant.active.filter(
              (a: any) => a.warehouse === selectedWarehouse?.value,
            ),
          },
        })),
      }));

      console.log("response.records", response.records);
      setProducts(response.records);
    } else {
      setProducts([]);
    }
    setLoading(false);
  };
  const handleActive = async (event: any) => {
    setActive(event);
    setKey(listAllProducts.currentTab, parseInt(event));
    setKey(listAllProducts.page, 1);
    setPage(1);
    setTotalRecords(0);
    await fetchProducts(1, pageLimit, productState, categories, search, event);
  };
  const handleVariationShow = (variantionData: any, index: number) => {
    let temp: any = [...products];
    temp[index].showVariant = !temp[index].showVariant;
    setProducts(temp);
  };

  const isPharmacyProductRecord = (productOrVariant: any, parentProduct?: any) => {
    const productLevel = productOrVariant?.isPharmacyProduct;
    const nestedProductLevel = productOrVariant?.product?.isPharmacyProduct;
    const firstVariantLevel = productOrVariant?.variants?.[0]?.variant?.isPharmacyProduct;
    const firstVariantNestedProductLevel =
      productOrVariant?.variants?.[0]?.variant?.product?.isPharmacyProduct;
    const parentLevel = parentProduct?.isPharmacyProduct;

    return (
      productLevel === true ||
      nestedProductLevel === true ||
      firstVariantLevel === true ||
      firstVariantNestedProductLevel === true ||
      parentLevel === true
    );
  };
  const updateProductState = async (
    state: boolean,
    id: string,
    isProduct: boolean,
    productIndex: number,
    variantIndex: number,
  ) => {
    let temp = [...products];
    let apiService = new APICallService(
      product.updateProductState,
      productJSON.updateProductState({ activate: !state }),
      {
        id: id,
      },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response) {
      temp[productIndex].variants[variantIndex].variant.active[0].active =
        !state;

    }
    if (productState !== AllProduct) {
      temp.splice(productIndex, 1);
    }
    setProducts(temp);
  };
  const handleAvailableToSellToggle = async (
    variantId: string,
    currentState: boolean,
    productIndex: number,
    variantIndex: number,
  ) => {
    if (!selectedWarehouse?.value) {
      return;
    }
    let temp = [...products];
    let apiService = new APICallService(
      product.availableToSell,
      productJSON.updateAvailableToSell({ availableToSell: !currentState }),
      {
        variantId: variantId,
        warehouseId: selectedWarehouse.value,
      },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse.value,
    );
    let response = await apiService.callAPI();
    if (response) {
      const inventory =
        temp[productIndex].variants[variantIndex].variant.inventoryInfo || [];
      const warehouseInvIndex = inventory.findIndex(
        (x: any) => x.warehouseId === selectedWarehouse.value,
      );
      if (warehouseInvIndex !== -1) {
        inventory[warehouseInvIndex].availableToSell = !currentState;
      } else {
        inventory.push({
          warehouseId: selectedWarehouse.value,
          availableToSell: !currentState,
        });
      }
      temp[productIndex].variants[variantIndex].variant.inventoryInfo =
        inventory;
      setProducts(temp);
      success(
        response.message || "Available to sell status updated successfully",
      );
    }
  };
  const handleCategoryFilter = async (event: any) => {
    setCategories(event);
    setKey(listAllProducts.page, 1);
    setPage(1);
    await fetchProducts(1, pageLimit, productState, event, search, active);
  };
  const handleProductStateChange = async (event: any) => {
    setKey(listAllProducts.page, 1);
    setPage(1);
    await fetchProducts(1, pageLimit, event.value, categories, search, active);
    setProductState(event.value);
  };

  const handleProductTypeChange = async (event: any) => {
    const selectedType = event?.value || "all";
    setKey(listAllProducts.page, 1);
    setPage(1);
    setProductType(selectedType);
    await fetchProducts(
      1,
      pageLimit,
      productState,
      categories,
      search,
      active,
      selectedType,
    );
  };

  const debounce = useDebounce(fetchProducts, 500);
  const handleSearch = async (value: string) => {
    setSearch(value);
    setKey(listAllProducts.page, 1);
    setPage(1);
    await debounce(1, pageLimit, productState, categories, value, active);
  };
  const rejectModal = (value: any) => {
    setRejectedProduct(value);
    setShowRejectModal(true);
  };
  const handleCurrentPage = async (val: number) => {
    setPage(val);
    setKey(listAllProducts.page, val);
    await fetchProducts(
      val,
      pageLimit,
      productState,
      categories,
      search,
      active,
    );
  };
  const handleNextPage = async (val: number) => {
    setPage(val + 1);
    setKey(listAllProducts.page, val + 1);
    await fetchProducts(
      val + 1,
      pageLimit,
      productState,
      categories,
      search,
      active,
    );
  };
  const handlePreviousPage = async (val: number) => {
    setPage(val - 1);
    setKey(listAllProducts.page, val - 1);
    await fetchProducts(
      val - 1,
      pageLimit,
      productState,
      categories,
      search,
      active,
    );
  };
  const handlePageLimit = async (event: any) => {
    setPage(1);
    await setPageLimit(parseInt(event.target.value));
    setKey(listAllProducts.page, 1);
    setKey(listAllProducts.limit, parseInt(event.target.value));
    await fetchProducts(
      1,
      event.target.value,
      productState,
      categories,
      search,
      active,
    );
  };
  const handleViewDetails = async (currentId: string) => {
    let ids: any = [];
    let currentScrollY = window.scrollY;
    setKey(listAllProducts.scrollPosition, currentScrollY);
    setKey(listAllProducts.search, search, false);
    setKey(listAllProducts.filterState, productState, false);
    setKey(listAllProducts.filterCategories, categories, false);
    if (active === PendingProduct) {
      if (products.length) {
        products.map((productVal: any) => {
          productVal.variants.map((variantVal: any) => {
            ids.push(variantVal.variant._id);
          });
        });
      }
      // Check if currentId exists in ids array
      const currentIdIndex = ids.indexOf(currentId);
      if (currentIdIndex !== -1) {
        // Remove currentId from its current position
        ids.splice(currentIdIndex, 1);
        // Add currentId to the start of the array
        ids.unshift(currentId);
      }
      navigateTo("/all-products/product-details", {
        state: { ids: ids, status: active, moduleName: All_Products },
      });
    } else {
      navigateTo("/all-products/product-details", {
        state: { id: currentId, moduleName: All_Products },
      });
    }
  };

  const openMenuOnClick = async (id: any) => {
    setId(id);
    setShow(true);
    // navigate('/master/edit-business-certificates', { state: data })
  };
  const onMenuClose = async () => {
    setId("");
    setShow(false);
  };

  const onMenuOpen = async (id: any) => {
    setId(id);
    setShow(true);
  };
  const handleOption = async (event: any, data: any, index: number) => {
    let currentScrollY = window.scrollY;
    setKey(listAllProducts.scrollPosition, currentScrollY);
    setKey(listAllProducts.search, search, false);
    setKey(listAllProducts.filterState, productState, false);
    setKey(listAllProducts.filterCategories, categories, false);
    if (event.value === 1) {
      navigate("/products/edit-product", {
        state: {
          _id: data._id,
          isMaster: false,
          moduleName: All_Products,
        },
      });
    } else if (event.value === 2) {
      setDeleteProductModalOpen(true);
      setSelectedProduct(data);
    } else if (event.value === 0) {
    } else if (event.value === 3) {
      setSearchTag(true);
      setSelectedProduct(data);
    }
  };
  const handleVariantOption = async (
    event: any,
    productId: any,
    data: any,
    index: number,
  ) => {
    let currentScrollY = window.scrollY;
    setKey(listAllProducts.scrollPosition, currentScrollY);
    setKey(listAllProducts.search, search, false);
    setKey(listAllProducts.filterState, productState, false);
    setKey(listAllProducts.filterCategories, categories, false);
    if (event.value === 1) {
      navigate("/products/edit-product-variant", {
        state: {
          _id: data._id,
          isMaster: false,
          moduleName: All_Products,
        },
      });
    } else if (event.value === 2) {
      setDeleteVariantModalOpen(true);
      setSelectedVariant(data);
      setProductId(productId);
    } else if (event.value === 0) {
    }
  };

  const handleProductDelete = async () => {
    setDeleteLoader(true);
    let apiService = new APICallService(
      product.deleteProduct,
      selectedProduct?._id,
      "",
      "",
      "",
      true,
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
    } else {
      setPage(1);
      setKey(listAllProducts.page, 1);
      fetchProducts(1, pageLimit, productState, categories, search, active);
      success(catalogue.deleted);
      setDeleteProductModalOpen(false);
    }
    setDeleteLoader(false);
  };

  const handleProductModalHide = () => {
    setDeleteProductModalOpen(false);
    setError("");
  };

  const handleVariantDelete = async () => {
    let variantId = selectedVariant?._id;
    setDeleteLoader(true);
    let apiService = new APICallService(
      product.deleteProductVariant,
      "",
      { productId, variantId },
      "",
      "",
      true,
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
    } else {
      setPage(1);
      setKey(listAllProducts.page, 1);
      fetchProducts(1, pageLimit, productState, categories, search, active);
      success(masterToast.deleteVariant);
      setDeleteVariantModalOpen(false);
    }
    setDeleteLoader(false);
  };

  const handleVariantModalHide = () => {
    setDeleteVariantModalOpen(false);
    setError("");
  };

  return (
    <div className="p-5">
      {showRejectModal ? (
        <ProductRejected
          show={showRejectModal}
          onHide={() => setShowRejectModal(false)}
          rejectedProduct={rejectedProduct}
        />
      ) : (
        <></>
      )}
      {showDownloadModal ? (
        <AllProductsReport
          show={showDownloadModal}
          onHide={() => setShowDownloadModal(false)}
          moduleName={All_Products}
        />
      ) : (
        <></>
      )}
      {showDownloadPriceListModal ? (
        <ProductPriceListReport
          show={showDownloadPriceListModal}
          onHide={() => setShowDownloadPriceListModal(false)}
          moduleName={All_Products}
        />
      ) : (
        <></>
      )}
      {deleteProductModalOpen && (
        <DeleteModal
          show={deleteProductModalOpen}
          onHide={handleProductModalHide}
          service={selectedProduct}
          handleDelete={handleProductDelete}
          error={error}
          loading={deleteLoader}
          serviceName="product"
          message={`Are you sure you want to delete ${selectedProduct.title} product?`}
          warnMessage={`By continuing, the ${selectedProduct.title} product will
          be removed permanently`}
        />
      )}
      {deleteVariantModalOpen && (
        <DeleteModal
          show={deleteVariantModalOpen}
          onHide={handleVariantModalHide}
          service={selectedVariant}
          handleDelete={handleVariantDelete}
          error={error}
          loading={deleteLoader}
          serviceName="variant"
          message={`Are you sure you want to delete ${selectedVariant.title} variant?`}
          warnMessage={`By continuing, the ${selectedVariant.title} variant will
          be removed permanently`}
        />
      )}
      {showSearchTag && (
        <EditSearchTags
          show={showSearchTag}
          onHide={() => setSearchTag(false)}
          data={selectedProduct}
          onClose={async () => {
            setSearchTag(false);
            await fetchProducts(
              1,
              pageLimit,
              productState,
              categories,
              search,
              active,
            );
          }}
        />
      )}
      <Row className="align-items-center">
        <Col xs className="mb-5">
          <h1 className="fs-22 fw-bolder">All products</h1>
        </Col>
        {currentUser?.role.length === 0 ||
          currentUser?.role.some((obj: any) => obj.type === FinanceManager) ? (
          <Col xs="auto">
            <Button
              size="lg"
              className="uw-btn uw-btn-primary uw-btn-lg mb-5"
              data-analytics-event="all_products_download_price_list_clicked"
              onClick={() => setShowDownloadPriceListModal(true)}
            >
              Download Product Price List
            </Button>
          </Col>
        ) : (
          <></>
        )}
        {currentUser?.role.length === 0 ||
          currentUser?.role.some((obj: any) => obj.type === FinanceManager) ? (
          <Col xs="auto">
            <Button
              size="lg"
              className="uw-btn uw-btn-primary uw-btn-lg mb-5"
              data-analytics-event="all_products_download_report_clicked"
              onClick={() => setShowDownloadModal(true)}
            >
              Download report
            </Button>
          </Col>
        ) : (
          <></>
        )}

        <Col xs={12}>
          <Card className="bg-light border mb-7">
            <Card.Body className="px-7">
              <Row className="align-items-center">
                <Col xl={4} lg={12} className="mb-xl-0 mb-5">
                  <div className="d-flex align-items-center position-relative me-lg-4">
                    <KTSVG
                      path="/media/icons/duotune/general/gen021.svg"
                      className="svg-icon-3 position-absolute ms-3"
                    />
                    <input
                      type="text"
                      id="kt_filter_search"
                      className="form-control form-control-white min-h-60px form-control-lg ps-10"
                      placeholder="Search by product name…"
                      onChange={(event: any) => {
                        handleSearch(event.target.value.trimStart());
                      }}
                      value={search}
                    />
                  </div>
                </Col>
                <Col xl={8}>
                  <Row className="align-items-center justify-content-xl-end g-3 flex-nowrap">
                    <Col md="auto" className="mb-0">
                      <div className="min-w-lg-250px">
                        <CustomComponentSelect
                          // onChange={(options: any) => {
                          //   if (Array.isArray(options)) {
                          //   }
                          // }}
                          //isDisabled={loading}
                          value={categories}
                          defaultValue={categories}
                          hideSelectedOptions={false}
                          isLoading={fetchCategoryLoader}
                          options={filterProducts}
                          onMenuClose={() => {
                            onMenuCategoryClose();
                          }}
                          onMenuOpen={() => {
                            onMenuCategoryOpen();
                          }}
                          onMenuScrollToBottom={
                            onMenuCategoryScrollToBottom
                          }
                          onInputChange={(
                            newValue: any,
                            { action }: any,
                          ) => {
                            if (action === "input-change") {
                              handleInputCategoryChange(newValue);
                            }
                          }}
                          onChange={(event: any) => {
                            handleCategoryFilter(event);
                          }}
                          isMulti={true}
                        />
                      </div>
                    </Col>
                    {active === ApprovedProduct ? (
                      <Col md="auto" className="mb-0">
                        <div className="min-w-lg-150px">
                          <CustomSelect
                            backgroundColor="white"
                            // default={[
                            //   {
                            //     value: AllProduct,
                            //     name: "All products",
                            //     label: (
                            //       <>
                            //         <span className="fs-16 fw-600 text-black mb-0">
                            //           All products
                            //         </span>
                            //       </>
                            //     ),
                            //     title: "All products",
                            //   },
                            // ]}
                            isDisabled={loading}
                            options={productOptions}
                            default={
                              productOptions.find(
                                (option) => option?.value === productState,
                              ) || productOptions[0]
                            }
                            onChange={(event: any) => {
                              handleProductStateChange(event);
                            }}
                            isMulti={false}
                          />
                        </div>
                      </Col>
                    ) : (
                      <></>
                    )}
                    <Col md="auto" className="mb-0">
                      <div className="min-w-lg-180px">
                        <CustomSelect
                          backgroundColor="white"
                          isDisabled={loading}
                          options={productTypeOptions}
                          isClearable={true}
                          placeholder="Product Type"
                          default={
                            productTypeOptions.find(
                              (option) => option?.value === productType,
                            ) || null
                          }
                          value={
                            productTypeOptions.find(
                              (option) => option?.value === productType,
                            ) || null
                          }
                          onChange={(event: any) => {
                            handleProductTypeChange(event);
                          }}
                          isMulti={false}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        ) : (
          <Col xs={12}>
            <div className="custom-tabContainer">
              <Tab.Container
                defaultActiveKey={active}
                onSelect={async () => {
                  setCategories([]);
                  setSearch("");
                  setProductState(AllProduct);
                }}
              >
                <Row className="variant-categories">
                  {currentUser?.role.some(
                    (obj: any) =>
                      obj.type === FinanceManager ||
                      obj.type === LoadingBayManager,
                  ) ? (
                    <></>
                  ) : (
                    <Col lg={"auto"} className="mb-6">
                      <div className="bg-light border border-r8px p-3 px-md-6">
                        <Nav variant="pills">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={PendingProduct}
                              onClick={() => {
                                handleActive(PendingProduct);
                              }}
                              data-analytics-event="all_products_pending_tab_clicked"
                              active={active === PendingProduct}
                            >
                              Pending{" "}
                              {active === PendingProduct
                                ? totalRecords > 0
                                  ? "(" + totalRecords + ")"
                                  : ""
                                : ""}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey={ApprovedProduct}
                              onClick={() => {
                                handleActive(ApprovedProduct);
                              }}
                              data-analytics-event="all_products_approved_tab_clicked"
                              active={active === ApprovedProduct}
                            >
                              Approved{" "}
                              {active === ApprovedProduct
                                ? totalRecords > 0
                                  ? "(" + totalRecords + ")"
                                  : ""
                                : ""}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey={RejectedProduct}
                              onClick={() => {
                                handleActive(RejectedProduct);
                              }}
                              data-analytics-event="all_products_rejected_tab_clicked"
                              active={active === RejectedProduct}
                            >
                              Rejected{" "}
                              {active === RejectedProduct
                                ? totalRecords > 0
                                  ? "(" + totalRecords + ")"
                                  : ""
                                : ""}
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                    </Col>
                  )}
                  <Col xs={12}>
                    <Tab.Content>
                      <>
                        <Tab.Pane active={true}>
                          <Card className="border border-r10px">
                            <Card.Body className="p-0">
                              <div className="table-responsive">
                                <table className="table table-rounded table-row-bordered align-middle gs-7 gy-4 mb-0">
                                  <thead>
                                    <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-70px align-middle">
                                      <th className="col-w-30">Product name</th>
                                      <th className="col-w-10">Is Pharmacy Product</th>
                                      <th className="col-w-20">
                                        {active === PendingProduct
                                          ? "Added on"
                                          : ""}
                                        {active === ApprovedProduct
                                          ? "Approved on"
                                          : ""}
                                        {active === RejectedProduct
                                          ? "Rejected on"
                                          : ""}
                                      </th>
                                      {Method.hasPermission(
                                        PermissionModule.All_Products,
                                        Permissions.Edit,
                                        currentUser,
                                      ) && active === ApprovedProduct ? (
                                        <th className="col-w-15">
                                          Activate / Deactivate
                                        </th>
                                      ) : null}
                                      {Method.hasPermission(
                                        PermissionModule.All_Products,
                                        Permissions.Edit,
                                        currentUser,
                                      ) && active === ApprovedProduct ? (
                                        <th className="col-w-15">
                                          Available To Sell
                                        </th>
                                      ) : null}
                                      <th className="col-w-20 text-end"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {loading ? (
                                      <tr>
                                        <td
                                          colSpan={
                                            active === ApprovedProduct ? 6 : 5
                                          }
                                        >
                                          <div className="w-100 d-flex justify-content-center">
                                            <Loader loading={loading} />
                                          </div>
                                        </td>
                                      </tr>
                                    ) : products.length ? (
                                      products.map(
                                        (productVal: any, index: number) => {
                                          return (
                                            <>
                                              <tr>
                                                <td>
                                                  <></>
                                                  <div className="d-flex align-items-center">
                                                    <div className="symbol symbol-50px border me-5">
                                                      <ImageWithFallback
                                                        src={
                                                          productVal.variants[0]
                                                            .variant.media[0]
                                                            .url
                                                        }
                                                        className="object-fit-contain"
                                                        alt="Product Image"
                                                      />
                                                    </div>
                                                    <div className="fs-15 fw-600 mw-lg-175px">
                                                      {productVal.title.replace(
                                                        /\s*\)\s*/g,
                                                        ")",
                                                      )}
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <span className="d-block fs-15 fw-600 text-dark">
                                                    {isPharmacyProductRecord(productVal) ? "Yes" : "No"}
                                                  </span>
                                                </td>
                                                <td>
                                                  {productVal.variants.length &&
                                                    productVal.variants[0]
                                                      .variant[
                                                    "variantType"
                                                    ][0] != undefined ? (
                                                    <span className="d-block fs-15 fw-600 text-dark">
                                                      -
                                                    </span>
                                                  ) : (
                                                    <>
                                                      {active ===
                                                        ApprovedProduct ? (
                                                        <span className="d-block fs-15 fw-600 text-dark">
                                                          {Method.convertDateToDDMMYYYYHOURS(
                                                            productVal
                                                              ?.variants[0]
                                                              ?.variant
                                                              ?.approvalInfo
                                                              ?.date,
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <></>
                                                      )}
                                                      {active ===
                                                        PendingProduct ? (
                                                        <span className="d-block fs-15 fw-600 text-dark">
                                                          {Method.convertDateToDDMMYYYYHOURS(
                                                            productVal
                                                              .variants[0]
                                                              .variant
                                                              ._createdAt,
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <></>
                                                      )}
                                                      {active ===
                                                        RejectedProduct ? (
                                                        <span className="d-block fs-15 fw-600 text-dark">
                                                          {Method.convertDateToDDMMYYYYHOURS(
                                                            productVal
                                                              .variants[0]
                                                              .variant
                                                              .rejectionInfo
                                                              .date,
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </>
                                                  )}
                                                </td>
                                                {Method.hasPermission(
                                                  PermissionModule.All_Products,
                                                  Permissions.Edit,
                                                  currentUser,
                                                ) &&
                                                  active === ApprovedProduct ? (
                                                  <>
                                                    <td>
                                                      {productVal.variants
                                                        .length &&
                                                        productVal.variants[0]
                                                          .variant[
                                                        "variantType"
                                                        ][0] != undefined ? (
                                                        <span className="fs-20 fw-600">
                                                          -
                                                        </span>
                                                      ) : (
                                                        <label className="form-check form-switch form-check-custom form-check-solid ">
                                                          <input
                                                            className="form-check-input form-check-success w-50px h-30px"
                                                            type="checkbox"
                                                            name="notifications"
                                                            value={
                                                              productVal
                                                                .variants[0]
                                                                .variant["_id"]
                                                            }
                                                            disabled={currentUser?.role.some(
                                                              (obj: any) =>
                                                                obj.type ===
                                                                LoadingBayManager,
                                                            )}
                                                            checked={
                                                              productVal
                                                                ?.variants[0]
                                                                ?.variant
                                                                ?.active[0]
                                                                ?.active
                                                            }
                                                            onChange={() => {
                                                              updateProductState(
                                                                productVal
                                                                  ?.variants[0]
                                                                  ?.variant
                                                                  ?.active[0]
                                                                  ?.active,
                                                                productVal
                                                                  ?.variants[0]
                                                                  ?.variant[
                                                                "_id"
                                                                ],
                                                                true,
                                                                index,
                                                                0,
                                                              );
                                                            }}
                                                          />
                                                        </label>
                                                      )}
                                                    </td>
                                                    <td>
                                                      {productVal.variants
                                                        .length &&
                                                        productVal.variants[0]
                                                          .variant[
                                                        "variantType"
                                                        ][0] != undefined ? (
                                                        <span className="fs-20 fw-600">
                                                          -
                                                        </span>
                                                      ) : (
                                                        <label className="form-check form-switch form-check-custom form-check-solid">
                                                          <input
                                                            className="form-check-input form-check-success w-50px h-30px"
                                                            type="checkbox"
                                                            disabled={
                                                              !selectedWarehouse?.value
                                                            }
                                                            checked={
                                                              productVal.variants[0].variant.inventoryInfo?.find(
                                                                (x: any) =>
                                                                  x.warehouseId ===
                                                                  selectedWarehouse?.value,
                                                              )
                                                                ?.availableToSell ||
                                                              true
                                                            }
                                                            onChange={() => {
                                                              handleAvailableToSellToggle(
                                                                productVal
                                                                  .variants[0]
                                                                  .variant._id,
                                                                productVal.variants[0].variant.inventoryInfo?.find(
                                                                  (x: any) =>
                                                                    x.warehouseId ===
                                                                    selectedWarehouse?.value,
                                                                )
                                                                  ?.availableToSell ||
                                                                true,
                                                                index,
                                                                0,
                                                              );
                                                            }}
                                                          />
                                                        </label>
                                                      )}
                                                    </td>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                                <td className="text-end">
                                                  <div className="d-flex flex-nowrap justify-content-end align-items-center">
                                                    {productVal.variants
                                                      .length &&
                                                      productVal.variants[0]
                                                        .variant[
                                                      "variantType"
                                                      ][0] != undefined ? (
                                                      <span
                                                        className="fs-16 fw-600 text-gray text-hover-primary cursor-pointer me-3"
                                                        onClick={() => {
                                                          handleVariationShow(
                                                            products.variants,
                                                            index,
                                                          );
                                                        }}
                                                      >
                                                        {productVal.showVariant
                                                          ? "Hide"
                                                          : "View"}{" "}
                                                        {
                                                          productVal.variants
                                                            .length
                                                        }{" "}
                                                        variations
                                                      </span>
                                                    ) : (
                                                      <>
                                                        <div className="d-inline-flex flex-nowrap">
                                                          {Method.hasPermission(
                                                            All_Products,
                                                            View,
                                                            currentUser,
                                                          ) ? (
                                                            <>
                                                              <Button
                                                                variant="primary"
                                                                className="uw-btn uw-btn-primary btn-active-light-primary fs-14 fw-600 me-5"
                                                                data-analytics-event="all_products_details_view_details_clicked"
                                                                onClick={() => {
                                                                  handleViewDetails(
                                                                    productVal
                                                                      .variants[0]
                                                                      .variant[
                                                                    "_id"
                                                                    ],
                                                                  );
                                                                }}
                                                              >
                                                                View details
                                                              </Button>
                                                              {active ===
                                                                RejectedProduct ? (
                                                                <Button
                                                                  variant="light-primary"
                                                                  className="uw-btn me-3 btn-active-light-primary fs-14 fw-600"
                                                                  data-analytics-event="all_products_details_view_rejection_reason_clicked"
                                                                  onClick={() => {
                                                                    rejectModal(
                                                                      productVal
                                                                        .variants[0],
                                                                    );
                                                                  }}
                                                                >
                                                                  View Reason
                                                                </Button>
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </div>
                                                      </>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                              {productVal.showVariant ? (
                                                productVal.variants.map(
                                                  (
                                                    variantVal: any,
                                                    variantIndex: number,
                                                  ) => {
                                                    return (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            <div className="d-flex align-items-center">
                                                              <div className="symbol symbol-50px border me-5">
                                                                <ImageWithFallback
                                                                  src={
                                                                    variantVal
                                                                      .variant
                                                                      .media[0]
                                                                      .url
                                                                  }
                                                                  className="object-fit-contain"
                                                                  alt="Product Image"
                                                                />
                                                              </div>
                                                              <div className="fs-15 fw-600 mw-lg-175px">
                                                                {variantVal.variant.title.replace(
                                                                  /\s*\)\s*/g,
                                                                  ")",
                                                                )}
                                                              </div>
                                                            </div>
                                                          </td>
                                                          <td>
                                                            <span className="d-block fs-15 fw-600 text-dark">
                                                              {isPharmacyProductRecord(variantVal?.variant, productVal)
                                                                ? "Yes"
                                                                : "No"}
                                                            </span>
                                                          </td>
                                                          {active ===
                                                            ApprovedProduct ? (
                                                            <td>
                                                              <span className="d-block fs-15 fw-600 text-dark">
                                                                {Method.convertDateToDDMMYYYYHOURS(
                                                                  variantVal
                                                                    ?.variant
                                                                    ?.approvalInfo
                                                                    ?.date,
                                                                )}
                                                              </span>
                                                            </td>
                                                          ) : (
                                                            <></>
                                                          )}
                                                          {active ===
                                                            PendingProduct ? (
                                                            <td>
                                                              <span className="d-block fs-15 fw-600 text-dark">
                                                                {Method.convertDateToDDMMYYYYHOURS(
                                                                  variantVal
                                                                    .variant
                                                                    ._createdAt,
                                                                )}
                                                              </span>
                                                            </td>
                                                          ) : (
                                                            <></>
                                                          )}
                                                          {active ===
                                                            RejectedProduct ? (
                                                            <td>
                                                              <span className="d-block fs-15 fw-600 text-dark">
                                                                {Method.convertDateToDDMMYYYYHOURS(
                                                                  variantVal
                                                                    .variant
                                                                    .rejectionInfo
                                                                    .date,
                                                                )}
                                                              </span>
                                                            </td>
                                                          ) : (
                                                            <></>
                                                          )}

                                                          {Method.hasPermission(
                                                            PermissionModule.All_Products,
                                                            Permissions.Edit,
                                                            currentUser,
                                                          ) &&
                                                            active ===
                                                            ApprovedProduct ? (
                                                            <>
                                                              <td>
                                                                <label className="form-check form-switch form-check-custom form-check-solid ">
                                                                  <input
                                                                    className="form-check-input form-check-success w-50px h-30px"
                                                                    type="checkbox"
                                                                    name="notifications"
                                                                    value={
                                                                      variantVal
                                                                        ?.variant
                                                                        ?._id
                                                                    }
                                                                    checked={
                                                                      variantVal
                                                                        ?.variant
                                                                        ?.active[0]
                                                                        ?.active
                                                                    }
                                                                    disabled={currentUser?.role.some(
                                                                      (
                                                                        obj: any,
                                                                      ) =>
                                                                        obj.type ===
                                                                        LoadingBayManager,
                                                                    )}
                                                                    onChange={() => {
                                                                      updateProductState(
                                                                        variantVal
                                                                          ?.variant
                                                                          ?.active[0]
                                                                          ?.active,
                                                                        variantVal
                                                                          ?.variant
                                                                          ?._id,
                                                                        false,
                                                                        index,
                                                                        variantIndex,
                                                                      );
                                                                    }}
                                                                  />
                                                                </label>
                                                              </td>
                                                              <td>
                                                                <label className="form-check form-switch form-check-custom form-check-solid">
                                                                  <input
                                                                    className="form-check-input form-check-success w-50px h-30px"
                                                                    type="checkbox"
                                                                    disabled={
                                                                      !selectedWarehouse?.value
                                                                    }
                                                                    checked={
                                                                      variantVal.variant.inventoryInfo?.find(
                                                                        (
                                                                          x: any,
                                                                        ) =>
                                                                          x.warehouseId ===
                                                                          selectedWarehouse?.value,
                                                                      )
                                                                        ?.availableToSell
                                                                    }
                                                                    onChange={() => {
                                                                      handleAvailableToSellToggle(
                                                                        variantVal
                                                                          .variant
                                                                          ._id,
                                                                        variantVal.variant.inventoryInfo?.find(
                                                                          (
                                                                            x: any,
                                                                          ) =>
                                                                            x.warehouseId ===
                                                                            selectedWarehouse?.value,
                                                                        )
                                                                          ?.availableToSell,
                                                                        index,
                                                                        variantIndex,
                                                                      );
                                                                    }}
                                                                  />
                                                                </label>
                                                              </td>
                                                            </>
                                                          ) : (
                                                            <></>
                                                          )}
                                                          <td className="text-end">
                                                            <div className="d-flex flex-nowrap justify-content-end align-items-center">
                                                              {Method.hasPermission(
                                                                All_Products,
                                                                View,
                                                                currentUser,
                                                              ) ? (
                                                                <>
                                                                  <Button
                                                                    variant="primary"
                                                                    className="uw-btn uw-btn-primary me-3 btn-active-light-primary fs-14 fw-600"
                                                                    data-analytics-event="all_products_details_view_details_clicked"
                                                                    onClick={() => {
                                                                      handleViewDetails(
                                                                        variantVal
                                                                          .variant[
                                                                        "_id"
                                                                        ],
                                                                      );
                                                                    }}
                                                                  >
                                                                    View details
                                                                  </Button>
                                                                  {active ===
                                                                    RejectedProduct ? (
                                                                    <Button
                                                                      variant="light-primary"
                                                                      className="uw-btn me-3 btn-active-light-primary fs-14 fw-600"
                                                                      data-analytics-event="all_products_details_view_rejection_reason_clicked"
                                                                      onClick={() => {
                                                                        rejectModal(
                                                                          variantVal,
                                                                        );
                                                                      }}
                                                                    >
                                                                      View
                                                                      Reason
                                                                    </Button>
                                                                  ) : (
                                                                    <></>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </>
                                                    );
                                                  },
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          );
                                        },
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={
                                            active === ApprovedProduct ? 6 : 5
                                          }
                                        >
                                          <div className="w-100 fs-15 fw-bold d-flex justify-content-center">
                                            No Data found
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </Card.Body>
                          </Card>
                          {!loading ? (
                            <>
                              {products.length ? (
                                <Pagination
                                  totalRecords={totalRecords}
                                  currentPage={page}
                                  handleCurrentPage={(event: any) => {
                                    handleCurrentPage(event);
                                  }}
                                  handleNextPage={(event: any) => {
                                    handleNextPage(event);
                                  }}
                                  handlePreviousPage={(event: any) => {
                                    handlePreviousPage(event);
                                  }}
                                  pageLimit={pageLimit}
                                  handlePageLimit={(event: any) => {
                                    handlePageLimit(event);
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </Tab.Pane>
                      </>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};
export default AllProducts;
